<template>
  <div>
    <div class="row">
      <div class="locutorContent locutores">
        <loading v-if="! showContent"></loading>
        <div class="col-md-12"><h1 class="titulo">{{ title }}</h1></div>
        <div class="col-md-6" v-for="locutor in items">
          <img v-if="locutor.imageLocutor" :src="locutor.imageLocutor" class="locutor">
          <img v-if="!locutor.imageLocutor" src="dist/images/sem_imagem.jpg" class="locutor">
          <h3>
            <router-link :to="getUrl(locutor.idLocutor, locutor.nameLocutor)">{{ locutor.nameLocutor }}</router-link>
          </h3>
          <a v-if="locutor.site" :href="locutor.site" target="_blank" class="site-url">{{ locutor.site }}</a>
          <p>
            {{ locutor.descriptionLocutor }}
          </p>
          <!--<p v-for="item in locutor.socialsNetworks"> {{ item.type }} </p>-->

          <div class="redes_sociais" v-if="locutor">
            <a target="_blank" v-for="socialnetwork in locutor.socialsNetworks"
               :href="socialnetwork.url" v-if="socialnetwork.url">
              <i :class="getIcon(socialnetwork)" aria-hidden="true"></i>
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .locutorContent {
    overflow: hidden;
    position: relative;
    width: 100%;
    min-height: 50px;
  }

  .locutorContent i {
    font-size: 3em;
  }
</style>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import {slugify} from '../helpers/slugify';

  export default {
    components: {
      Loading
    },
    data() {
      return {
        title: 'Locutores',
        showContent: false,
        items: [],
        icons: [
          {
            type: 'instagram',
            icon: 'fab fa-instagram'
          },
          {
            type: 'facebook',
            icon: 'fab fa-facebook-f'
          },
          {
            type: 'twitter',
            icon: 'fab fa-twitter'
          },
          {
            type: 'soundCloud',
            icon: 'fab fa-soundcloud'
          },
          {
            type: 'youtube',
            icon: 'fab fa-youtube'
          },
          {
            type: 'google',
            icon: 'fab fa-google-plus-g'
          },
          {
            type: 'whatsapp',
            icon: 'fab fa-whatsapp'
          },
          {
            type: 'blog',
            icon: 'fab fa-rss'
          },
          {
            type: 'myspace',
            icon: 'fab fa-share-alt'
          },
          {
            type: 'flickr',
            icon: 'fab fa-flickr'
          },
          {
            type: 'lastfm',
            icon: 'fab fa-lastfm'
          },
          {
            type: 'viber',
            icon: 'fab fa-share-alt'
          },
          {
            type: 'skype',
            icon: 'fab fa-skype'
          },
          {
            type: 'snapchat',
            icon: 'fab fa-snapchat-ghost'
          }
        ]
      }
    },
    created() {
      let self = this;
      get('locutors').then(function (response) {
        // self.items = this.$store.getters['getSiteContent'].result.data.locutor;
        self.items = response.data.result.data;
        self.showContent = true;
      })
    },
    methods: {
      getIcon(item) {
        let currentIcon = '';
        this.icons.forEach(function (value) {
          if (value.type === item.type) {
            currentIcon = value.icon;
          }
        });

        return currentIcon;
      },
      getUrl(id, string) {
        return '/locutor/' + id + '/' + slugify(string);
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Locutores.vue